<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useUiStore } from '@/stores/ui.js';

const ui = useUiStore();
const { toasts } = storeToRefs(ui);
</script>

<template>
  <div aria-live="polite" aria-atomic="false" class="toast-stack">
    <div
      v-for="t in toasts"
      :key="t.id"
      :class="['toast', `toast--${t.kind}`]"
      role="status"
    >
      <span class="toast__message">{{ t.message }}</span>
      <button
        type="button"
        class="toast__dismiss"
        :aria-label="`Dismiss notification: ${t.message}`"
        @click="ui.dismissToast(t.id)"
      >
        ×
      </button>
    </div>
  </div>
</template>

<style scoped>
.toast-stack {
  position: fixed;
  bottom: var(--space-4);
  right: var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 24rem;
  z-index: var(--z-toast);
}

.toast {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-3);
  font-size: var(--font-size-sm);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
}

.toast__message {
  flex: 1;
}

.toast__dismiss {
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  opacity: 0.8;
  cursor: pointer;
}

.toast__dismiss:hover {
  opacity: 1;
}

.toast--info {
  background: var(--color-feedback-info-bg);
  color: var(--color-feedback-info-fg);
}

.toast--success {
  background: var(--color-feedback-success-bg);
  color: var(--color-feedback-success-fg);
}

.toast--warning {
  background: var(--color-feedback-warning-bg);
  color: var(--color-feedback-warning-fg);
}

.toast--error {
  background: var(--color-feedback-danger-bg);
  color: var(--color-feedback-danger-fg);
}
</style>
